import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MotionWrapper from '../../component/MotionWrapper';
import axios from 'axios';
import Letter from '../../component/Spring/Letter';
import Dday_Spring from '../../component/Spring/Dday_Spring';
import Message_Spring from '../../component/Spring/Message_Spring';
import Location_Spring from '../../component/Spring/Location_Spring';
import Footer from '../../component/Footer';
import Loading from '../../component/Loading';
import Location_Desc from '../../component/Location/Location_Desc';
import Music from '../../component/Music';
import AccountList from '../../component/Account/AccountList';
import Sharing from '../../component/Sharing';
import GalleryList from '../../component/Gallery/GalleryList';
import Main_Summer from '../../component/Summer/Main_Summer';
import Save_Date from '../../component/Save_Date';
import Interview_Spring from '../../component/Spring/Interview_Spring';
import CallInfo from '../../component/CallInfo';
import Information from '../../component/Information';
import Info_Spring2 from '../../component/Spring/Info_Spring2';


const KimDaYe = () => {
    const navigate = useNavigate(); 
    const { mainPage } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(true);
    const [fontsLoaded, setFontsLoaded] = useState(false);

    const openTitle = "김영광 ♥ 김다예";
    const openDesc = "2025.06.28 SAT 11:00am";
    const openThumb = "https://moodsean.s3.ap-northeast-2.amazonaws.com/208/thumb.jpg";

    const lng = 127.07141185507;
    const lat = 37.540657941434;

    const placeTelNum = "02-430-8000";

    const forParking = "- 건물 내 B1~B5\n(2시간 무료 주차)\n- 건국대학교 병원 지상&지하 주차장\n(1시간 30분 무료 주차)"
    const forSubway = "- 2호선 건대입구역 2번 출구\n- 7호선 건대입구역 3번 출구"
    const forBus = "* ‘건대입구역, 건대입구역 사거리’ 하차\n- 간선 240번, 721번, N61번, N62번\n- 지선 2016번, 2222번, 3217번, 3220번, 4212번\n- 직행 102번, 3500번\n- 공항 6013번"

    const [weddingData, setWeddingData] = useState({
        id:'',
        concept: '',
        weddingDate: '',
        invitationInfoId: '',
        brideName: '',
        groomName: '',
        brideNameEn: '',
        groomNameEn: '',
        year:'',
        month:'',
        date:'',
        dayOfWeek:'',
        time:'',
        place:'',
        address:'',
        mainImg:'',
        subImg:'',
        pointColor: '',
        btnFontColor: '',
        btnBgColor: '',
        isGuestBookOpen: ''
    });


    const conceptStyle = {
        // summer 블루
        concept: "SUMMER",
        titleColor: "#505D89",
        pointColor: "#505D89",
        btnBgColor: "#505D89",
        fontColor: "#ffffff",
        btnFontColor: "#ffffff",
        chatBgColor: "#F5F8FF",
        fontFamilyKo: "SCDream3",
        fontFamilyEn: "Edensor"
    }

    const title = "우리 결혼합니다.";

    const msg1 = "하나님 안에서 서로를 만나\n사랑이 언약이 되고\n기도가 약속이 되어\n이제 하나의 가정을 이루려 합니다."
    const msg2 = "믿음으로 시작하는 이 여정에\n귀한 걸음으로 함께해 주신다면 감사하겠습니다."
    const msg3 = "\n\n우리가 서로 사랑하면 \n하나님이 우리 안에 거하시고 \n그의 사랑이 우리 안에 \n온전히 이루어지느니라\n- 요한일서 4장 12절"


    const parents = [
        {groom : "❁박금주 · 이윤실의 장남"},
        {bride : "이학두 · 최경숙의 차녀"}
    ]

    const groomAccountList = [
        {
            role: "신랑",
            name: "김영광",
            bank: "국민은행",
            accountNumber : "96244897851",
            isKakao : false
        }
        ,{
            role: "신랑 부·모",
            name: "김유겸",
            bank: "농협은행",
            accountNumber : "531142-52-048161",
            isKakao : false
        }
        // ,{
        //     role: "신랑",
        //     name: "김찬안미경주",
        //     bank: "농협은행",
        //     accountNumber : "356-0245-3851-13",
        //     isKakao : false
        // }
    ]

    const brideAccountList = [
        {
            role: "신부 ",
            name: "김다예",
            bank: "하나은행",
            accountNumber : "159-910865-54107",
            isKakao : false
        }
        ,{
            role: "신부 부·모",
            name: "김성환",
            bank: "농협은행",
            accountNumber : "238-02-183195",
            isKakao : false
        }
        // ,{
        //     role: "신부",
        //     name: "배다민",
        //     bank: "농협은행",
        //     accountNumber : "352-1043-7794-53",
        //     isKakao : true,
        //     kakaoUrl : "https://qr.kakaopay.com/Ej7nwOd76"
        // }
    ]

    const account_explain = "따로 계좌번호를 여쭤보시는 수고를 덜기 위해 기입합니다. \n부담 안가지셨으면 좋겠습니다."

    const interviewContent = [
        {
            question : "서로의 첫 인상은 어땠어?",
            groomAnswer: "나랑닮았네!",
            brideAnswer: "나랑닮았네?"
        },
        {
            question : "결혼을 앞둔 소감이 어때?",
            groomAnswer: "드림컴트루★",
            brideAnswer: "세상든든해"
        },
        {
            question : "유부남/녀 기념으로 각오 한 마디!",
            groomAnswer: "곁에있을게",
            brideAnswer: "매일예쁠게"
        },
        {
            question : "우리가 꿈꾸는 가정은?",
            groomAnswer: "딸둘아들둘",
            brideAnswer: "웃음넘치는"
        },
        {
            question : "마지막으로 손님들께 전하고 싶은 이야기는?",
            groomAnswer: "고맙습니다♥︎",
            brideAnswer: "많이많이요♥︎"
        },
    ]

    const groomCallInfoList = [
        {
            role: "신랑",
            name: "김영광",
            call: "010-6244-8978"
        }
        ,{
            role: "신랑 부",
            name: "김유겸",
            call: "010-9856-7702"
        }
        ,{
            role: "신랑 모",
            name: "유성림",
            call: "010-6380-7706"
        }
    ]

    const brideCallInfoList = [
        {
            role: "신부",
            name: "김다예",
            call: "010-2055-8891"
        }
        ,{
            role: "신부 부",
            name: "김성환",
            call: "010-6393-1917"
        }
        ,{
            role: "신부 모",
            name: "박수정",
            call: "010-3711-1922"
        }
    ]

    const informationList =[
        {
            title : "화환 안내",
            content : "화환은 정중히 사양합니다. \n축하해주시는 고마운 마음만 \n감사히 받겠습니다. "
        }
    ]

    const fetchInvitationInfoData = async () => {
        try {
            const response = await axios.get(`${API_URL}/_api/v1/invitation_info/${mainPage}`);
            if(response.status === 200){
                const [y, m, d] = response.data.data.weddingDate.split('-');

                setWeddingData(prevData => {
                    const newData = {
                        id: response.data.data.id,
                        concept: response.data.data.concept,
                        weddingDate: response.data.data.weddingDate,
                        invitationInfoId: response.data.data.id,
                        brideName: response.data.data.brideNameKo,
                        groomName: response.data.data.groomNameKo,
                        brideNameEn: response.data.data.brideNameEn,
                        groomNameEn: response.data.data.groomNameEn,
                        year: y,
                        month: m,
                        date: d,
                        dayOfWeek: response.data.data.dayOfWeek,
                        time: response.data.data.time,
                        place: response.data.data.place,
                        address: response.data.data.address,
                        mainImg: response.data.data.mainImg,
                        subImg: response.data.data.subImg,
                        pointColor: response.data.data.pointColor,
                        btnBgColor: response.data.data.btnBgColor,
                        btnFontColor: response.data.data.btnFontColor,
                        isGuestBookOpen: response.data.data.isGuestBookOpen
                    };
                    return newData;
                });
            } 
        } catch (error) {
            console.error("API 요청 실패:", error.response ? error.response.data : error.message);
        }
    };

    useEffect(() => {
        const fetchDataSequentially = async () => {
            if (!weddingData.weddingDate) {  
                await fetchInvitationInfoData();
            }
        };
        fetchDataSequentially();  
    
        document.body.style.overflow = 'hidden';
    
        const timer = setTimeout(() => {
            document.body.style.overflow = '';
        }, 3000);
    
        return () => {
            clearTimeout(timer);
            document.body.style.overflow = '';
        };
    }, []);

    useEffect(() => {
        const fontLoadObserver = async () => {
            await document.fonts.ready; 
            setFontsLoaded(true); 
            setLoading(false);
        };
        if(!weddingData.weddingDate){
            fontLoadObserver();
        }
    }, []);

    const goToGuestBook = () => {
        navigate(`/${mainPage}/guest`); 
    };

    // 성을 제외하고 이름만 추출 ex. 가영
    const getFirstKoName = (fullName) => {
        const nameParts = fullName.split(''); 
        return nameParts.slice(1).join(''); 
    };

    // 성을 제외하고 이름만 추출 ex.Gayeong
    const getFirstNameEn = (fullName) => {
        const nameParts = fullName.split(' '); 
        const firstName = nameParts.slice(1).join(''); 
        return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    };

    // ex. Kim Gayeong
    const getRemoveSpaceName = (fullName) => {
        const nameParts = fullName.split(' '); // 문자열을 띄어쓰기로 분리
        const firstName = nameParts[0]; // 첫 번째 단어 유지
        const restName = nameParts.slice(1).join(''); // 나머지 단어를 소문자로 변경하고 결합
        return firstName + ' ' + restName.charAt(0).toUpperCase() + restName.slice(1).toLowerCase();
    };

        // 성을 제외하고 이름만 추출 ex.Gayeong
        const getFirstEnName = (fullName) => {
            const nameParts = fullName.split(' '); 
            const firstName = nameParts.slice(1).join(''); 
            return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
        };
        
        // 브라운 #5b0100
        // #761B40
        // #423866
        // #d98db9
        // #FF8A83
    return (
        <div>
            {loading || !fontsLoaded ? (
                <Loading color={"#505D89"} loading={loading} />
            ) : (
                <>
                    <Music concept={conceptStyle.concept} />
                    <Main_Summer weddingData={weddingData} groomNameEn={getRemoveSpaceName(weddingData.brideNameEn)} brideNameEn={getRemoveSpaceName(weddingData.groomNameEn)} color={"#505D89"} letteringFontColor={"#ffffff"} dateColor={"#ffffff"} bottom={"25%"} bottom2={"15.5%"} dateBottom={"1%"} top={"1%"}/>
                    <Save_Date color={conceptStyle.pointColor} isBorder={true} marginTop={"100px"} marginBottom={"10px"} fontSize={"13px"} />
                    <Info_Spring2  weddingData={weddingData} conceptStyle={conceptStyle} brideNameEn={weddingData.brideNameEn} groomNameEn={weddingData.groomNameEn}/>
                    <Letter title={title} msg1={msg1} msg2={msg2} msg3={msg3} conceptStyle={conceptStyle} />
                    <CallInfo marginTop={"30px"} conceptStyle={conceptStyle} groomCallInfoList={groomCallInfoList} brideCallInfoList={brideCallInfoList}/>
                    <Dday_Spring isAttendFromClose={true} brideName={getFirstKoName(weddingData.brideName)} groomName={getFirstKoName(weddingData.groomName)} weddingData={weddingData} conceptStyle={conceptStyle}/>
                    <MotionWrapper initialY={50}>
                        <GalleryList fontFamilyKo={conceptStyle.fontFamilyKo} fontFamilyEn={conceptStyle.fontFamilyEn} color={conceptStyle.titleColor} weddingData={weddingData} initCount={6} photoWidth={"150px"} photoHeight={"235px"} gap={"3px"}/>
                    </MotionWrapper>
                    <MotionWrapper initialY={70}>
                        <AccountList conceptStyle={conceptStyle} groomAccountList={groomAccountList} brideAccountList={brideAccountList} account_explain={account_explain} />
                    </MotionWrapper>
                        <Information conceptStyle={conceptStyle} informationList={informationList} />
                    <MotionWrapper initialY={70}>
                        <Message_Spring weddingData={weddingData} goToGuestBook={goToGuestBook} weddingDate={weddingData.weddingDate} 
                            conceptStyle={conceptStyle} 
                            btnBgColor={weddingData.btnBgColor} btnFontColor={weddingData.btnFontColor} titleColor={weddingData.titleColor}
                            />
                    </MotionWrapper>
                    <MotionWrapper initialY={50}>
                        <Interview_Spring interviewContent={interviewContent} weddingData={weddingData} conceptStyle={conceptStyle} />
                        <Location_Spring weddingData={weddingData} conceptStyle={conceptStyle} lng={lng} lat={lat} placeTelNum={placeTelNum}/>
                    </MotionWrapper>
                    <Location_Desc isPoint={true} forParking={forParking} forSubway={forSubway} forBus={forBus} conceptStyle={conceptStyle}/>
                    <Sharing conceptStyle={conceptStyle} title={openTitle} description={openDesc} thumbImg={openThumb}/>
                    <Footer />
                </>
            )}
        </div>
    );
    
};

export default KimDaYe;